import { render, staticRenderFns } from "./utools.vue?vue&type=template&id=6f04c974&scoped=true"
import script from "./utools.vue?vue&type=script&lang=js"
export * from "./utools.vue?vue&type=script&lang=js"
import style0 from "./utools.vue?vue&type=style&index=0&id=6f04c974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04c974",
  null
  
)

export default component.exports